// recon-equity-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rce.cat.shareCapital': 'Capital social',
  'rce.cat.cooperativeCapital': 'Capital cooperativo en copropiedad',
  'rce.cat.sharePremium': 'Prima de emisión',
  'rce.cat.otherPaidIn': 'Otro patrimonio neto aportado',
  'rce.cat.funds': 'Fondos',
  'rce.cat.otherEarned': 'Otro patrimonio neto generado',
  'rce.cat.dividendProvision': 'Dividendo provisionado contra el patrimonio neto',
  'rce.cat.privateAccount': 'Cuenta privada, retiros y aportaciones',
  'rce.cat.uncoveredLoss': 'Pérdida no cubierta / patrimonio neto negativo',
  'rce.cat.otherEquity': 'Otro patrimonio neto',
  'rce.type.dividendProvision': 'Dividendo provisionado',
  'rce.type.profitAllocation': 'Distribución del resultado',
  'rce.type.yearEndEntry': 'Asiento de cierre contra el patrimonio neto',
  'rce.type.distribution': 'Distribución al propietario',
  'rce.type.ownerCurrentAccount': 'Transacción contra la cuenta corriente con el propietario',
  'rce.type.receipt': 'Cobro contabilizado contra el patrimonio neto',
  'rce.type.payment': 'Pago contabilizado contra el patrimonio neto',
  'rce.flag.noDecisionBasis': 'Falta la base de la decisión',
  'rce.flag.dispositionUnverified': 'La distribución aprobada no se puede verificar',
  'rce.flag.calcDifference': 'Diferencia de cálculo',
  'rce.item.counterAccount': 'Contracuenta {codes}',
  'rce.item.statementDiff': '{label} — el saldo final calculado difiere del contabilizado',
  'rce.item.accounts': 'Cuentas: {codes}',
  'rce.item.driftTitle': '{code} {name} — el movimiento del libro mayor no explica la variación del saldo',
  'rce.item.driftDetail': 'El balance de comprobación y los justificantes no coinciden en el movimiento de la cuenta.',
  'rce.item.negativeTitle': 'El patrimonio neto calculado es negativo',
  'rce.item.negativeDetail': 'El patrimonio neto negativo debe ser evaluado por el consejo de administración y documentarse.',
  'rce.item.noShareCapitalTitle': 'No hay capital social contabilizado en las cuentas de patrimonio neto',
  'rce.item.noShareCapitalDetail': 'Una sociedad anónima debe tener capital social contabilizado.',
  'rce.item.noRegisterTitle': 'El libro registro de acciones no está registrado en Plumme',
  'rce.item.noRegisterDetail': 'Sin libro registro de acciones no se pueden comprobar ni la propiedad ni las distribuciones frente a los propietarios.',
  'rce.decision.recorded': 'Junta general registrada en Plumme',
  'rce.decision.uploaded': 'Acta subida',
  'rce.disp.dividend': 'Dividendo ordinario',
  'rce.disp.transfer': 'Traspasado a otro patrimonio neto',
  'rce.disp.total': 'Total distribuido',
  'rce.src.ledger': 'Libro mayor y balance de comprobación',
  'rce.src.protocol': 'Acuerdo de la junta general',
  'rce.src.register': 'Libro registro de acciones',
  'rce.src.annual': 'Cuentas anuales aprobadas del ejercicio anterior',
  'rce.src.registry': 'Capital social registrado y cambios de capital (Foretaksregisteret)',
  'rce.src.forecast': 'Presupuesto y previsión de liquidez',
  'rce.src.ledgerDetail': 'Las cuentas de patrimonio neto con el saldo inicial y los movimientos en lo que va de año.',
  'rce.src.protocolMissing': 'No hay junta general registrada ni acta subida para el ejercicio.',
  'rce.src.registerDetail': '{count} accionistas con un total de {shares} acciones',
  'rce.src.registerMissing': 'No hay accionistas registrados en Plumme.',
  'rce.src.articlesMissing': 'Los estatutos no se han subido al área.',
  'rce.src.annualMissing': 'No se pudo leer el resultado del ejercicio anterior.',
  'rce.src.annualDetail': 'Resultado del ejercicio {year}: {result} kr',
  'rce.src.registryDetail': 'Plumme no obtiene el capital social registrado ni los cambios de capital. Se comprueba manualmente con el registro.',
  'rce.src.forecastDetail': 'Hay un presupuesto para el ejercicio. La aplicación no obtiene una previsión de liquidez propia.',
  'rce.src.forecastMissing': 'No hay presupuesto ni previsión de liquidez disponibles para el ejercicio.',
  'rce.check.rollforward': 'El patrimonio neto inicial más los movimientos es igual al final',
  'rce.check.vouchers': 'Los movimientos están respaldados por justificantes',
  'rce.check.decision': 'Las distribuciones tienen una base de decisión documentada',
  'rce.check.allocation': 'La distribución contabilizada suma el resultado del ejercicio anterior',
  'rce.check.direct': 'Los asientos directos contra el patrimonio neto están identificados',
  'rce.check.owners': 'Las transacciones con propietarios están identificadas',
  'rce.check.capital': 'El requisito de capital de la forma societaria está contabilizado',
  'rce.check.weak': 'Señales de patrimonio neto débil o negativo',
});
